<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-spin :spinning="loading">
        <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-item label="">
            <div class="s_flex_ali">
              <div class="s_flex_ali s_width160 m-r-15">
                <a-checkbox v-model:checked="form.is_sales" @change="onChange"></a-checkbox>
                <p class="s_c333 m-l-10">销售额，每达到：</p>
              </div>
              <div class="width40 m-r-15">
                <a-input-number v-model:value="form.sales" style="width:100%" placeholder='请输入云店销售额' v-inputFilter:price :disabled="!form.is_sales" />
              </div>
              <div class="m-r-15">
                <p>元，增加1成长值</p>
              </div>
              <div>
                <a-tooltip placement="right">
                  <template #title>
                    店员在云店商城的销售业绩（订单须结算），每次达到设定的销售额，可获得1成长值
                  </template>
                  <QuestionCircleOutlined class="s_c376" />
                </a-tooltip>
              </div>
            </div>
          </a-form-item>
          <a-form-item label="">
            <div class="s_flex_ali">
              <div class="s_flex_ali s_width160 m-r-15">
                <a-checkbox v-model:checked="form.is_scan_count" @change="onChange"></a-checkbox>
                <p class="s_c333 m-l-10">扫码次数，每达到：</p>
              </div>
              <div class="width40 m-r-15">
                <a-input-number v-model:value="form.scan_count" style="width:100%" placeholder='请输入扫码次数'  :disabled="!form.is_scan_count" />
              </div>
              <div class="m-r-15">
                <p>次，增加1成长值</p>
              </div>
              <div>
                <a-tooltip placement="right">
                  <template #title>
                    店员个人扫描导购码的有效扫码次数（导购码的首次扫码是该店员），每达到设定的次数，可获得1成长值
                  </template>
                  <QuestionCircleOutlined class="s_c376" />
                </a-tooltip>
              </div>
            </div>
          </a-form-item>
          <!-- <a-form-item label="">
            <div class="s_flex_ali">
              <div class="s_flex_ali s_width160 m-r-15">
                <a-checkbox v-model:checked="form.is_invite_count" @change="onChange"></a-checkbox>
                <p class="s_c333 m-l-10">邀约人数，每达到：</p>
              </div>
              <div class="width40 m-r-15">
                <a-input-number v-model:value="form.invite_count" style="width:100%" placeholder='请输入邀约人数' :min='1' :disabled="!form.is_invite_count" />
              </div>
              <div class="m-r-15">
                <p>人，增加1成长值</p>
              </div>
              <div>
                <a-tooltip placement="right">
                  <template #title>
                    店员每次邀约生成的绑定客户，达到设定的人数，可获得 1 成长值
                  </template>
                  <QuestionCircleOutlined class="s_c376" />
                </a-tooltip>
              </div>
            </div>
          </a-form-item> -->
          <a-form-item label="">
            <div class="s_flex_ali">
              <div class="s_flex_ali s_width160 m-r-15">
                <a-checkbox v-model:checked="form.is_scan_product" @change="onChange"></a-checkbox>
                <p class="s_c333 m-l-10">扫码产品，每扫码：</p>
              </div>
              <div class="width40 m-r-15">
                <a-input-number v-model:value="form.scan_product" style="width:100%" placeholder='请输入邀约人数' :disabled="!form.is_scan_product" />
              </div>
              <div class="m-r-15">
                <p>元，增加1成长值</p>
              </div>
              <div>
                <a-tooltip placement="right">
                  <template #title>
                    导购员扫描导购二维码时（有效扫码即导购码首次扫码人数该店员），会根据扫码产品的价格增加对应的成长值；比如设置扫码产品价格达到50元增加1成长值，则扫描一个价格为100元的产品会增加2成长值，扫描价格为30元的不增加成长值，扫描价格为50元的增加1成长值
                  </template>
                  <QuestionCircleOutlined class="s_c376" />
                </a-tooltip>
              </div>
            </div>
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 8, offset: 2 }">
            <a-button style="width:100px" type="primary" v-has:clerkLevelSetup="onSubmit">
              保存
            </a-button>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-card>
  </a-layout>
</template>
<script>
import { QuestionCircleOutlined } from "@ant-design/icons-vue";
import { ref, onMounted, reactive, toRefs, inject } from "vue";
import { message } from "ant-design-vue";
import { getStoreClerkPurchase, setStoreClerkPurchase } from "@/api/clerk";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defForm = {
  sales: 0,
  scan_count: 0,
  invite_count: 0,
  is_sales: 0,
  is_scan_count: 0,
  is_invite_count: 0,
  is_scan_product: 0,
  scan_product: 0,
};
export default {
  name: "setUp",
  components: {
    QuestionCircleOutlined,
  },
  setup() {
    const form = ref({ ...defForm });
    const state = reactive({
      labelCol: { span: 2 },
      wrapperCol: { span: 22 },
      loading: false,
    });
    const getMore = async () => {
      state.loading = true;
      let res = await getStoreClerkPurchase().then((res) => res.data);
      if (iscode(res)) {
        state.loading = false;
        form.value = res.data;
      } else {
        state.loading = false;
        message.error(res.msg);
      }
    };
    getMore();
    const ruleForm = ref();
    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(async () => {
          const hide = message.loading("正在加载中...", 0);
          let res = await setStoreClerkPurchase({
            ...form.value,
            is_sales: form.value.is_sales ? 1 : 0,
            is_scan_count: form.value.is_scan_count ? 1 : 0,
            is_invite_count: form.value.is_invite_count ? 1 : 0,
            is_scan_product: form.value.is_scan_product ? 1 : 0,
          }).then((res) => res.data);
          if (iscode(res)) {
            setTimeout(hide);
            message.success(res.msg);
          } else {
            setTimeout(hide);
            message.error(res.msg);
          }
        })
        .catch((error) => {
          message.error("请完善表单！");
        });
    };
    return {
      form,
      ...toRefs(state),
      ruleForm,
      onSubmit,
    };
  },
};
</script>
<style>
.s_width160 {
  width: 160px;
}
</style>
